'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var customerPortalArticlesMap = {
  cz_cz: { lang: 'cz', consent: 23874 },
  de_de: { lang: 'de', consent: 23873 },
  el_gr: { lang: 'lang-gr', consent: 23879 },
  en_gb: { lang: 'lang', consent: 23869 },
  es_es: { lang: 'es', consent: 23908 },
  es_sp: { lang: 'sp', consent: 23886 },
  fi_fi: { lang: 'fi', consent: 23871 },
  fr_fr: { lang: 'fr', consent: 23872 },
  hu_hu: { lang: 'hu', consent: 23876 },
  it_it: { lang: 'it', consent: 23892 },
  ja_jp: { lang: 'jp', consent: 23875 },
  pl_pl: { lang: 'pl', consent: 23878 },
  pt_pt: { lang: 'pt', consent: 23881 },
  ro_ro: { lang: 'ro', consent: 23880 },
  ru_ru: { lang: 'ru', consent: 23883 },
  sl_sl: { lang: 'si', consent: 23885 },
  sr_sr: { lang: 'rs', consent: 23882 },
  zh_cn: { lang: 'lang-sch', consent: 23884 },
  zh_hk: { lang: 'lang-tch', consent: 23888 }
};
/**
 * Returns customer portal link
 * @param {string} lang domain suffix
 * @param {string} id article id
 * @return {string} customer portal link
 */
var getCustomerPortalLink = function getCustomerPortalLink(lang, id) {
  return 'https://williamhill-' + lang + '.custhelp.com/app/answers/detail/a_id/' + id;
};

/**
 * Return CustomerPortal articles map for given locate
 * @param {string} local exp. en-gb or en_gb
 * @return {*} articles id map and lang
 */
var getCustomerPortalArticlesMap = function getCustomerPortalArticlesMap() {
  var local = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en_gb';

  var mapKey = local.replace('-', '_');
  return customerPortalArticlesMap[mapKey] || customerPortalArticlesMap.en_gb;
};

/**
 * Return CustomerPortal consent link for given locate
 * @param {string} local exp. en-gb or en_gb
 * @return {string} customer portal consent link
 */
var getCustomerPortalConsentLink = exports.getCustomerPortalConsentLink = function getCustomerPortalConsentLink(local) {
  var _getCustomerPortalArt = getCustomerPortalArticlesMap(local),
      lang = _getCustomerPortalArt.lang,
      consent = _getCustomerPortalArt.consent;

  return getCustomerPortalLink(lang, consent);
};